// moment 插件  dayjs 插件  都是处理时间格式
import dayjs from 'dayjs'
// 使用dayjs插件（按需）
import relativeTime from 'dayjs/plugin/relativeTime'
// 国际化
import 'dayjs/locale/zh-cn'
dayjs.locale('zh-cn')
// 添加插件
dayjs.extend(relativeTime)

const $sleep = (val) => {
  // return new Promise((resolve, reject) => {
  //   setTimeout(() => {
  //     // resolve(console.log('三秒之后执行'))
  //     resolve()
  //   }, 3000)
  // })
  return dayjs().from(val)
}

const time = (Vue) => {
  // Vue.prototype.$sleep = $sleep
  Vue.filter('relativeTime', $sleep)
}
export default time
